import type { CreditsUsageDay } from '../creditsApi'

export interface UsageBar {
  date: string
  spent: string
  /** Высота столбика 0..1 от самого дорогого дня; день без трат и возврат — 0. */
  ratio: number
  /** Компенсаций за день больше, чем трат: `spent` < 0 (контракт бэка). */
  refund: boolean
}

/**
 * Столбики графика трат. `Number` здесь — геометрия (высота), а не сумма для
 * показа: подпись берёт строку `spent` как есть. Отрицательный день рисуется
 * нулём — столбик вниз читался бы как трата.
 */
export const usageBars = (days: CreditsUsageDay[]): UsageBar[] => {
  const values = days.map((d) => Number(d.spent))
  const max = Math.max(0, ...values.filter(Number.isFinite))
  return days.map((d, i) => {
    const v = Number.isFinite(values[i]) ? values[i] : 0
    return { date: d.date, spent: d.spent, ratio: max > 0 && v > 0 ? v / max : 0, refund: v < 0 }
  })
}

/** Был ли за период хоть один день с тратами — иначе показываем пустое состояние. */
export const hasUsage = (bars: UsageBar[]): boolean => bars.some((b) => b.ratio > 0)

/** `YYYY-MM-DD` → локальная дата без сдвига поясом (`new Date('2026-09-25')` — это UTC). */
export const usageDate = (iso: string): Date => {
  const [y, m, d] = iso.split('-').map(Number)
  return new Date(y, m - 1, d)
}
